import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import jwt_decode from 'jwt-decode';
import { ModalErrorComponent } from '../modal-components/modal-error/modal-vacina-error-component';
import { AuthenticateService } from 'src/services/authenticate.service';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {

  ignora = ['apimeudigisus']

  constructor(
    private modalController: ModalController,
    private authService: AuthenticateService,
    private router: Router,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    console.log('===request====', request);

    if (request && request.headers) {
      if (
        (!this.tratarToken(request.headers.get('x-authorization-server')) ||
          !this.tratarToken(request.headers.get('authorization')))

        && !request.url.includes('autenticar-contexto')
      ) {

        const quebra = request.headers.get('authorization').split(' ');
        const decodedToken = jwt_decode(quebra[1]);

        let aToken = this.authService.getAuthorizationToken();
        let decodedAToken = jwt_decode(aToken);
        console.log('decodedAToken', decodedAToken);
        console.log('decodedToken', decodedToken);

        if (decodedAToken.iss === decodedToken.iss && !request.url.includes('autenticar-contexto')) {
          return from(this.authService.getIntegrationContext()).pipe(
            switchMap((a, b) => {
              console.log('======Gerando novo Contexto====');
              let newToken = this.authService.getAuthorizationToken();
              request = request.clone({
                setHeaders: {
                  'Content-Type': request.headers.get('Content-Type'),
                  Authorization: `Bearer ${newToken}`,
                  'X-Authorization-Server': request.headers.get('x-authorization-server')
                }
              })

              return next.handle(request).pipe(
                catchError((err) => {
                  return throwError(() => JSON.stringify(err));
                })
              );
            })
          )
        }

        this.modalErro();
        return of();
      }
    }

    return next.handle(request).pipe(
      catchError((err) => {
        return throwError(() => JSON.stringify(err));
      })
    );
  }

  ignoraRotas(rota: string) {
    return this.ignora.find(item => rota.includes(item));
  }

  async modalErro() {
    const modal = await this.modalController.create({
      component: ModalErrorComponent,
      keyboardClose: false,
      cssClass: "modal-error",
    });

    modal.onDidDismiss().then((event) => { });
    return modal.present();
  }

  tratarToken(token: string) {
    if (token && token.includes('Bearer')) {
      const quebra = token.split(' ');
      const decodedToken = jwt_decode(quebra[1]);
      const currentTimestamp = Math.floor(Date.now() / 1000);
      if (decodedToken.exp < currentTimestamp) {
        return false;
      }
    }
    return true;
  }
}

